import {
	ApiSignEntIdDeleteRequest,
	ApiSignEntIdGetRequest,
	ApiSignEntIdPutRequest,
	ApiSignGetRequest,
	ApiSignPostRequest,
	SignApi,
	SignDTO,
	SignDTOListBaseResponse,
} from "@api/client";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { errorHandler } from "core/store/config";
import { AppSearchboxActiveFilter } from "shared/design-system/components/app-searchbox/types.models";

enum SignReducer {
	setTablePage = "[SIGN] Set table page",
	setTablePageSize = "[SIGN] Set table page size",
	setTableSort = "[SIGN] Set table sort",
	addFilter = "[SIGN] Add filter",
	deleteFilter = "[SIGN] Delete filter",
	getList = "[SIGN] Get",
	getDetails = "[SIGN] Get Details",
	create = "[SIGN] Create",
	edit = "[SIGN] Edit",
}

export const signSetTablePage = createAction<number>(SignReducer.setTablePage);

export const signSetTablePageSize = createAction<number>(
	SignReducer.setTablePageSize
);

export const signSetTableSort = createAction<keyof SignDTO>(
	SignReducer.setTableSort
);

export const signAddFilter = createAction<AppSearchboxActiveFilter>(
	SignReducer.addFilter
);

export const signDeleteFilter = createAction<string>(SignReducer.deleteFilter);

export const signGetList = createAsyncThunk<
	SignDTOListBaseResponse | undefined,
	void,
	ThunkApiConfig
>(SignReducer.getList, async (_, { getState }) => {
	try {
		let state = getState()?.private.sign;

		let request: ApiSignGetRequest = {
			page: state.page,
			pageSize: state.pageSize,
			orderBy: state.orderBy,
			orderByDir: state.orderByDir,
		};

		let filters: { [key in keyof ApiSignGetRequest]: any } = {};

		state?.filters?.forEach((f) => {
			filters[f.key as keyof ApiSignGetRequest] = f.value;
		});

		request = { ...request, ...filters };

		return await new SignApi(getConfiguration()).apiSignGet(request);
	} catch (e) {
		errorHandler(e);
	}
});

export const signGetDetails = createAsyncThunk<
	SignDTO | undefined,
	number,
	ThunkApiConfig
>(SignReducer.getDetails, async (id, {}) => {
	try {
		let request: ApiSignEntIdGetRequest = {
			entId: id,
		};

		return await new SignApi(getConfiguration()).apiSignEntIdGet(request);
	} catch (e) {
		errorHandler(e);
	}
});

export const signCreate = createAsyncThunk<
	SignDTO | undefined,
	ApiSignPostRequest,
	ThunkApiConfig
>(SignReducer.create, async (values, {}) => {
	try {
		let request: ApiSignPostRequest = {
			...values,
		};

		return await new SignApi(getConfiguration()).apiSignPost(request);
	} catch (e) {
		errorHandler(e);
	}
});

export const signEdit = createAsyncThunk<
	SignDTO | undefined,
	ApiSignEntIdPutRequest,
	ThunkApiConfig
>(SignReducer.edit, async (values, {}) => {
	try {
		let request: ApiSignEntIdPutRequest = {
			...values,
		};

		return await new SignApi(getConfiguration()).apiSignEntIdPut(request);
	} catch (e) {
		errorHandler(e);
	}
});

export const signDelete = createAsyncThunk<
	void | undefined,
	number,
	ThunkApiConfig
>(SignReducer.edit, async (entId, {}) => {
	try {
		let request: ApiSignEntIdDeleteRequest = {
			entId,
		};

		return await new SignApi(getConfiguration()).apiSignEntIdDelete(request);
	} catch (e) {
		errorHandler(e);
	}
});
